import { TILE_CONFIG } from "@/config";
import { Vector, vec } from "excalibur";

export const tileToWorld = (tile: Vector) => {
  // Convert tile coordinates to world coordinates
  const x = tile.x * TILE_CONFIG.TILE_WIDTH + TILE_CONFIG.TILE_WIDTH / 2; // Center of the tile
  const y = tile.y * TILE_CONFIG.TILE_HEIGHT + TILE_CONFIG.TILE_HEIGHT / 2; // Center of the tile

  return vec(x, y);
};

export const worldToTile = (pos: Vector) => {
  // Ensure you're dividing by the actual tile width and height
  const x = Math.floor(pos.x / TILE_CONFIG.TILE_WIDTH);
  const y = Math.floor(pos.y / TILE_CONFIG.TILE_HEIGHT);

  return vec(x, y);
};

type Position = {
  x: number;
  y: number;
};

export const getOccupiedTilesByCount = (
  furniturePos: Position, // Use the Position type for the furniture position
  tileCount: number,
  isVertical: boolean = false // New parameter to determine vertical or horizontal
): { x: number; y: number }[] => {
  // Explicit return type
  const occupiedTiles: { x: number; y: number }[] = []; // Type the array

  // Loop through the number of tiles based on the orientation (horizontal or vertical)
  for (let dx = 0; dx < tileCount; dx++) {
    if (isVertical) {
      occupiedTiles.push({
        x: furniturePos.x, // Keep the x coordinate constant
        y: furniturePos.y - dx, // Modify the y coordinate for vertical direction
      });
    } else {
      occupiedTiles.push({
        x: furniturePos.x + dx, // Modify the x coordinate for horizontal direction
        y: furniturePos.y, // Keep the y coordinate constant
      });
    }
  }

  return occupiedTiles;
};

export const getOccupiedTilesByCountFull = (
  furniturePos: { x: number; y: number },
  tileCount: number
) => {
  const result = {
    horizontal: [] as { x: number; y: number }[], // Explicitly typing the arrays
    vertical: [] as { x: number; y: number }[],
  };

  // Generate horizontal occupied tiles (moving right)
  for (let dx = 0; dx < tileCount; dx++) {
    result.horizontal.push({ x: furniturePos.x + dx, y: furniturePos.y });
  }

  // Generate vertical occupied tiles (moving down)
  for (let dy = 0; dy < tileCount; dy++) {
    result.vertical.push({ x: furniturePos.x, y: furniturePos.y + dy });
  }

  return result;
};
